/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single scraped room content item (room media from hotel chain websites)
 * @export
 * @interface ScrapedRoomContentItem
 */
export interface ScrapedRoomContentItem {
    /**
     * 
     * @type {number}
     * @memberof ScrapedRoomContentItem
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    chainName: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    roomCode: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    roomDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    roomCategory?: ScrapedRoomContentItemRoomCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    mediaLink: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    mediaName?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    mediaCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    mediaDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedRoomContentItem
     */
    mediaContentType: ScrapedRoomContentItemMediaContentTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ScrapedRoomContentItem
     */
    additionalDetails?: object;
}


/**
 * @export
 */
export const ScrapedRoomContentItemRoomCategoryEnum = {
    Standard: 'STANDARD',
    Suite: 'SUITE',
    Studio: 'STUDIO'
} as const;
export type ScrapedRoomContentItemRoomCategoryEnum = typeof ScrapedRoomContentItemRoomCategoryEnum[keyof typeof ScrapedRoomContentItemRoomCategoryEnum];

/**
 * @export
 */
export const ScrapedRoomContentItemMediaContentTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO'
} as const;
export type ScrapedRoomContentItemMediaContentTypeEnum = typeof ScrapedRoomContentItemMediaContentTypeEnum[keyof typeof ScrapedRoomContentItemMediaContentTypeEnum];


/**
 * Check if a given object implements the ScrapedRoomContentItem interface.
 */
export function instanceOfScrapedRoomContentItem(value: object): value is ScrapedRoomContentItem {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('chainName' in value) || value['chainName'] === undefined) return false;
    if (!('supplierId' in value) || value['supplierId'] === undefined) return false;
    if (!('roomCode' in value) || value['roomCode'] === undefined) return false;
    if (!('mediaLink' in value) || value['mediaLink'] === undefined) return false;
    if (!('mediaContentType' in value) || value['mediaContentType'] === undefined) return false;
    return true;
}

export function ScrapedRoomContentItemFromJSON(json: any): ScrapedRoomContentItem {
    return ScrapedRoomContentItemFromJSONTyped(json, false);
}

export function ScrapedRoomContentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapedRoomContentItem {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'chainName': json['chain_name'],
        'supplierId': json['supplier_id'],
        'roomCode': json['room_code'],
        'roomDescription': json['room_description'] == null ? undefined : json['room_description'],
        'roomCategory': json['room_category'] == null ? undefined : json['room_category'],
        'mediaLink': json['media_link'],
        'mediaName': json['media_name'] == null ? undefined : json['media_name'],
        'mediaCategory': json['media_category'] == null ? undefined : json['media_category'],
        'mediaDescription': json['media_description'] == null ? undefined : json['media_description'],
        'mediaContentType': json['media_content_type'],
        'additionalDetails': json['additional_details'] == null ? undefined : json['additional_details'],
    };
}

export function ScrapedRoomContentItemToJSON(json: any): ScrapedRoomContentItem {
    return ScrapedRoomContentItemToJSONTyped(json, false);
}

export function ScrapedRoomContentItemToJSONTyped(value?: ScrapedRoomContentItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'chain_name': value['chainName'],
        'supplier_id': value['supplierId'],
        'room_code': value['roomCode'],
        'room_description': value['roomDescription'],
        'room_category': value['roomCategory'],
        'media_link': value['mediaLink'],
        'media_name': value['mediaName'],
        'media_category': value['mediaCategory'],
        'media_description': value['mediaDescription'],
        'media_content_type': value['mediaContentType'],
        'additional_details': value['additionalDetails'],
    };
}

